import { ROUTE_PATHS } from '@/constants';
import type { IMenuItem } from '@/types';

export const menuItems: IMenuItem[] = [
  {
    id: 'dashboard',
    href: ROUTE_PATHS.userDashboard,
    label: 'ACCOUNT.MENU.DASHBOARD',
  },
  {
    id: 'quotes',
    href: ROUTE_PATHS.userQuotes,
    label: 'ACCOUNT.MENU.QUOTES',
  },
  {
    id: 'shipments',
    href: ROUTE_PATHS.usershipments,
    label: 'ACCOUNT.MENU.SHIPMENTS',
  },
];
